import LinkItem from "./LinkItem";

export default LinkItem;
